import moment from 'moment';
import event from '@shared/utils/EventBus';
import { useGlobalStore } from '@/stores/GlobalStore';

export function useHandleCommen() {
  const store = useGlobalStore();
  const handleValue = (value) => {
    return value ? Math.ceil(value).toLocaleString() : '---';
  };
  const handleNumSpec = (num) => {
    return num && num === -1 ? '---' : num || num === 0 ? Number(num * 100).toLocaleString('en-US') + '%' : '---';
  };

  const errorImage = (img) => {
    if(!img){
      return require('@/assets/images/no-image.png');
    }
    else if (img && !img.startsWith('http')) {
      return require('@/assets/images/no-image.png');
    } else if (img && !img.includes('.webp') && !img.includes('.jpeg') && !img.includes('.jpg') && !img.includes('.png') && !img.includes('.gif')) {
      return require('@/assets/images/no-image.png');
    } else {
      return img;
    }
  };

  const HandleKNum = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'm';
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'k';
    } else {
      return handleValue(num);
    }
  };

  const checkUrl = () => {
    if (window.location.hash === '#_') {
      const newUrl = window.location.href.replace('#_', ''); // ig回來會多奇怪的符號
      window.history.replaceState(null, null, newUrl); // 移除
    }
    if (window.location.hash === '#_=_') {
      const newUrl = window.location.href.replace('#_=_', ''); // ig回來會多奇怪的符號
      window.history.replaceState(null, null, newUrl); // 移除
    }
  };

  const toSlug = (name) => {
    let handleName= name ? name:'';
    return handleName
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-') // turn "-"
      .replace(/[^a-z0-9-]/g, ''); // only a-z, 0-9,  "-"
  };

  const showDate = (date) => {
    // check if date is today
    if (moment().format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD')) 
      return moment(date).format('hh:mm A');
    else 
      return moment(date).format('MM/DD/YYYY hh:mm A');
    
  };

  const handleConnactUs = () => {
    if (store.project === 'cj') {
      window.open('https://cjaffiliate.my.site.com/publisher/s/contactsupport', '_blank');
    } else {
      event.emit('open-global-drawer', 'help-support');
    }
  };

  return {
    handleValue,
    handleNumSpec,
    errorImage,
    HandleKNum,
    checkUrl,
    toSlug,
    showDate,
    handleConnactUs,
  };
}
